import type { Graphics } from "pixi.js";

/** A bounded ring in the existing effect batch; each shape starts its own path. */
export function drawExtractionRing(graphics: Graphics, x: number, y: number, progress: number, alpha = 1): void {
    const fraction = Math.max(0, Math.min(1, progress));
    if (!fraction || alpha <= 0) return;
    const radius = 58;
    const start = -Math.PI / 2;
    const end = start + fraction * Math.PI * 2;

    graphics.beginPath().circle(x, y, radius).stroke({ color: 0x122d35, width: 10, alpha: alpha * 0.65 });
    graphics.beginPath().circle(x, y, radius).stroke({ color: 0xb4eed4, width: 2, alpha: alpha * 0.25 });
    graphics.beginPath();
    for (let i = 0; i < 8; i++) {
        const angle = start + i * Math.PI / 4;
        const dx = Math.cos(angle), dy = Math.sin(angle);
        graphics.moveTo(x + dx * 66, y + dy * 66).lineTo(x + dx * 70, y + dy * 70);
    }
    graphics.stroke({ color: 0xd2f5e3, width: 2, alpha: alpha * 0.5, cap: "round" });

    // Explicit start prevents Pixi connecting the arc to an earlier coin or dash path.
    graphics.beginPath().moveTo(x, y - radius).arc(x, y, radius, start, end)
        .stroke({ color: 0x8df5c7, width: 9, alpha: alpha * 0.18, cap: "round" });
    graphics.beginPath().moveTo(x, y - radius).arc(x, y, radius, start, end)
        .stroke({ color: 0xb1ffdb, width: 4.5, alpha, cap: "round" });
    const tipX = x + Math.cos(end) * radius, tipY = y + Math.sin(end) * radius;
    graphics.beginPath().circle(tipX, tipY, 6).fill({ color: 0x8df5c7, alpha: alpha * 0.2 });
    graphics.beginPath().circle(tipX, tipY, 2.8).fill({ color: 0xf1fff6, alpha });
}
